module.exports = __webpack_public_path__ + "naglotech_logo.png?4470121a624293a5afdfcb742c3a3b59";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naglotech_logo.png
// module id = 37
// module chunks = 0